// extracted by mini-css-extract-plugin
export default {"form__group":"customInput_form__group__z+6WE","form__field":"customInput_form__field__Z2Rsr","form__label":"customInput_form__label__r4uwY"};